import $ from 'jquery';
import 'slick-carousel';

const selectors = {
	review: '#slider-review',
	triggerUpdateMain: '#js--main-update-reviews',
	people: '#slider-people',
	current: '.slick-current',
	slide: '.slick-slide',
	img: '.main-reviews__image'
};

const classes = {
	scale: 'animate-main-slider'
};

const addScale = next => () => {
	$(`[data-slick-index='${next}']`)
		.addClass(classes.scale);
};

const removeScale = () => {
	$(selectors.slide)
		.removeClass(classes.scale);
};

const animate = (event, slick, currentSlide, nextSlide) => {
	removeScale();
	setTimeout(addScale(nextSlide), 450);
};

const initSliders = () => {
	let isNewIndex = false;
	if (selectors.triggerUpdateMain !== null) {
		isNewIndex = true;
	}
	$(selectors.review).slick({
		infinite: true,
		arrows: false,
		fade: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 3,
		asNavFor: selectors.people,
		adaptiveHeight: isNewIndex,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					adaptiveHeight: isNewIndex,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					adaptiveHeight: true,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 540,
				settings: {
					centerMode: false,
					adaptiveHeight: true,
					slidesToScroll: 1
				}
			}
		]
	});

	$(selectors.people).slick({
		infinite: true,
		slidesToShow: 5,
		slidesToScroll: 3,
		arrows: false,
		speed: 500,
		asNavFor: selectors.review,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 1300,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 541,
				settings: {
					centerMode: false,
					slidesToShow: 1
				}
			}
		]
	});
};

const render = () => {

	initSliders();

	$(selectors.current)
		.addClass(classes.scale);

	$(selectors.people)
		.on('beforeChange', animate);
};

export default render;
